export * from './post-template.component';
export * from './post-template.component.module';